import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from '@/components/LanguageToggle';

const { FiArrowLeft } = FiIcons;

export default function Privacy() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const s = t.legal.sections;

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 pb-24">
      <LanguageToggle />
      <header className="sticky top-0 z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-900 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center">
          <button 
            onClick={() => navigate('/')}
            className="p-2 -ml-2 text-zinc-400 hover:text-zinc-50 transition-colors flex items-center gap-2 group"
          >
            <SafeIcon icon={FiArrowLeft} className="text-xl group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold tracking-widest uppercase">{t.ui.back}</span>
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 mt-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold tracking-tight mb-12">{t.legal.privacyTitle}</h1>
          
          <div className="space-y-12">
            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s1_title}</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">{s.s1_content}</p>
              <div className="text-zinc-300 font-medium">
                Mathias Deppe<br />
                Nemesi Valls 42<br />
                08210 Barberà del Vallès<br />
                Barcelona, Spain<br />
                Email: <a href="mailto:contact@barberadelvalles.bar" className="underline hover:text-white transition-colors">contact@barberadelvalles.bar</a>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s2_title}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.s2_content}</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s3_title}</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">{s.s3_content1}</p>
              <p className="text-zinc-400 leading-relaxed">{s.s3_content2}</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s4_title}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.s4_content}</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s5_title}</h2>
              <p className="text-zinc-400 leading-relaxed">{s.s5_content}</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-zinc-100 mb-4">{s.s6_title}</h2>
              <p className="text-zinc-400 leading-relaxed mb-4">{s.s6_content1}</p>
              <p className="text-zinc-400 leading-relaxed">{s.s6_content2}</p>
            </section>

            <footer className="pt-8 border-t border-zinc-900 flex flex-col gap-6">
              <p className="text-zinc-400">
                {s.footer} <a href="mailto:contact@barberadelvalles.bar" className="text-zinc-100 font-bold hover:underline">contact@barberadelvalles.bar</a>
              </p>
              
              <Link 
                to="/imprint" 
                className="text-[10px] font-bold tracking-[0.4em] uppercase text-zinc-500 hover:text-zinc-100 transition-colors"
              >
                {t.ui.imprint}
              </Link>
            </footer>
          </div>
        </motion.div>
      </main>
    </div>
  );
}